var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('client-request',{attrs:{"userloaded":_vm.userloaded,"customer-request":_vm.customerRequest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }